import { render, staticRenderFns } from "./AdBlockWarningModal.vue?vue&type=template&id=5fff5f16&scoped=true"
import script from "./AdBlockWarningModal.vue?vue&type=script&lang=js"
export * from "./AdBlockWarningModal.vue?vue&type=script&lang=js"
import style0 from "./AdBlockWarningModal.vue?vue&type=style&index=0&id=5fff5f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff5f16",
  null
  
)

export default component.exports